"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STYLES = exports.CONTRACT_CONSTANT_KEY = exports.ALLOWED_POSITION = void 0;
var DEFAULT_STYLES = {
  POSITION: 'absolute',
  CONTAINER_Z_INDEX: '15',
  OVERLAY_Z_INDEX: '10'
};
exports.DEFAULT_STYLES = DEFAULT_STYLES;
var ALLOWED_POSITION = ['fixed', 'absolute', 'relative'];
exports.ALLOWED_POSITION = ALLOWED_POSITION;
var CONTRACT_CONSTANT_KEY = {
  MEMBER: 'memberData',
  NAVIGATION: 'navigations',
  LOGOUT: 'logoutButton'
};
exports.CONTRACT_CONSTANT_KEY = CONTRACT_CONSTANT_KEY;